export default __webpack_public_path__ + "static/certification-signature-9bb5b7d7c861e5096997386bd037b62d.png";